import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const DashboardIndex = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();
  useEffect(() => {
    navigate(`${routePrefix}/${ROUTE_KEYS.OVERVIEW}`, { replace: true });
  }, []);
  return <div />;
};

export default DashboardIndex;
